import {
  AvroOptional,
  log as signalsLogRNGraphQLError,
} from "@indeed/signals-schema/com/indeed/signals/schema/reactnative/RNGraphQLErrorV5";

import type { NativeContextRNProps } from "../props/NativeContextRNProps";
import { getRnErrorProviderId } from "../util/getRnErrorProviderId";
import { isSSR } from "../util/isSSR";
import { getDeviceProperties } from "./LoggableDeviceProperties";

interface LogGraphQLErrorParams {
  provider: string;
  messages: string[];
  query: string;
  operationName: string;
  variables: string;
  nativeContext?: NativeContextRNProps;
}

export function logGraphQLErrors({
  provider,
  messages,
  query,
  operationName,
  variables,
  nativeContext,
}: LogGraphQLErrorParams): void {
  // Signals logging relies on browser/native APIs that are unavailable during SSR.
  if (isSSR()) return;
  const { ctk, accountId } = nativeContext ?? {};
  signalsLogRNGraphQLError({
    provider,
    providerId: { ProviderId: getRnErrorProviderId(provider) },
    messages,
    query,
    operationName: AvroOptional.string(operationName),
    deviceProperties: getDeviceProperties(),
    variables: AvroOptional.string(variables),
    ctk: AvroOptional.string(ctk),
    accountId: AvroOptional.string(accountId),
  });
}
